import { atom } from 'jotai'

/**
 * サイドメニューの幅
 */
export const sideMenuWidthAtom = atom<number>(200)

/**
 * サイドメニューの開閉状態
 */
export const sideMenuOpenedAtom = atom<boolean | null>(null)

/**
 * レイアウトのバリエーション
 *
 * レイアウトのバリエーションが指定されていな場合は AppRoute や GuardAuth で指定されているレイアウトを使用する
 */
export const layoutVariantAtom = atom<'default' | 'simple' | 'disable' | null>(null)

/**
 * canaly-app-main DOM
 */
export const layoutMainRefAtom = atom<HTMLDivElement | null>(null)
